import styled from 'styled-components';
import {
  Tabs,
  TabsList,
  Tab,
  TabPanel,
} from '@womcorp/wom-miwom-ui-kit/dist/components/Tabs';

const BundleDetailsHeaderTitleStyled = styled.h2`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: white;
  font-weight: 300;
  font-size: 17px;
  line-height: 22px;
  padding: 20px 25px 0;
  @media (max-width: 820px) {
    font-size: 14px;
  }
`;

const BundleDetailsTabsWrapperStyled = styled(Tabs)`
  width: 100%;

  .TabPanelUnstyled-root {
    color: white;
  }
`;

const BundleDetailsTabsListStyled = styled(TabsList)`
  && {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-top: 20px;
  }
`;

const BundleDetailsTabStyled = styled(Tab)`
  &&.TabUnstyled-root {
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: rgba(255, 255, 255, 0.5);

    &.Mui-selected {
      color: white;
    }
  }
`;

const BundleDetailsTabPanelWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  position: relative;
  top: 200px;
  min-height: max-content;
`;

const BundleDetailsTabPanelContentStyled = styled(TabPanel)`
  width: 100%;
  &&.TabPanelUnstyled-root {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

export {
  BundleDetailsHeaderTitleStyled,
  BundleDetailsTabsWrapperStyled,
  BundleDetailsTabsListStyled,
  BundleDetailsTabStyled,
  BundleDetailsTabPanelWrapperStyled,
  BundleDetailsTabPanelContentStyled,
};
